<!-- card header -->
<div class="flex px-3 py-2 border-solid border-0 border-b border-black/10">
  <div
    class="flex flex-1 overflow-hidden flex-col justify-center cursor-pointer">
    <b class="truncate">{{ channel.name }}</b>
    <span class="truncate text-xs text-black/60">
      {{ channel.numbers[0] || '–' }}
    </span>
  </div>
  <span
    class="material-symbols-rounded cursor-pointer max-w-0 group-hover:max-w-6 opacity-0 group-hover:opacity-100 transition-all"
    [routerLink]="[{ outlets: { modal: ['add', channel.uid] } }]"
    >edit</span
  >
</div>
<!-- feature toggles -->
<div class="flex flex-col gap-1 justify-center px-4">
  <div
    class="blu-menu-item"
    [class.active]="channel.activeAgent"
    [ngClass]="{
      'pointer-events-none !text-black/20':
        !canAddAgent() && !channel.activeAgent
    }"
    [routerLink]="
      canAddAgent() || channel.activeAgent
        ? [{ outlets: { modal: ['select-agent', channel.uid] } }]
        : null
    ">
    <span class="material-symbols-rounded">network_intelligence</span>
    Agente I.A.
  </div>
  <div
    class="blu-menu-item"
    [class.active]="channel.activeFlow"
    [routerLink]="[{ outlets: { modal: ['select-flow', channel.uid] } }]">
    <span class="material-symbols-rounded"> account_tree </span>
    Fluxo
  </div>
  <div
    class="blu-menu-item"
    [class.active]="channel.operators?.length"
    [routerLink]="[{ outlets: { modal: ['select-operator', channel.uid] } }]">
    <span class="material-symbols-rounded">support_agent</span>
    Atendentes
  </div>
</div>
<!-- activate button -->
@switch (channel.status) {
  @case ('CONNECTED') {
    <div
      class="flex gap-1 py-1 items-center justify-center text-white bg-green-600 font-bold">
      <span class="material-symbols-rounded">
        {{ channel.statusVersion === 2 ? 'check' : 'check_circle' }}
      </span>
      Ativo
    </div>
  }
  @case ('INITIALIZING') {
    <div
      class="flex gap-1 py-1 items-center justify-center text-white bg-yellow-600 font-bold">
      <span class="material-symbols-rounded"> hourglass_top </span>
      Inicializando...
    </div>
  }
  @case (undefined) {
    <kor-spinner size="s" class="py-1"></kor-spinner>
  }
  @default {
    <button
      class="rounded-none"
      [routerLink]="[{ outlets: { modal: ['activate', channel.uid] } }]">
      Ativar
    </button>
  }
}
